:host {
  --aha-date-input--error-color: var(--theme-error-message);
  --aha-date-input--border-color: var(--theme-primary-border);

  display: inline-flex;
  flex-direction: column;
  border-radius: var(--Common--border-radius);
  max-width: 100%;
  border: 1px solid var(--aha-date-input--border-color);
}
:host(:focus-within) {
  --aha-date-input--border-color: transparent;
  box-shadow: 0 0 0 2px rgba(var(--rgb-blue-500), 0.5);
}

.aha-date-input__wrapper {
  display: flex;
  align-items: stretch;
  height: 100%;
}
